import { render, staticRenderFns } from "./ConfirmBox.vue?vue&type=template&id=527402e3&scoped=true"
import script from "./ConfirmBox.vue?vue&type=script&lang=js"
export * from "./ConfirmBox.vue?vue&type=script&lang=js"
import style0 from "./ConfirmBox.vue?vue&type=style&index=0&id=527402e3&prod&scoped=true&lang=css"
import style1 from "./ConfirmBox.vue?vue&type=style&index=1&id=527402e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_abc276eb37b0b1314bfe9ec856cc5e10/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527402e3",
  null
  
)

export default component.exports